import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class SurveyService {
  constructor(private http: HttpClient) { }

  getSurvey(surveyId: string) {
    return this.http.get('/api/survey/' + surveyId);
  }

  postSurvey(surveyId: string, questionsArray: any) {
    return this.http.post('/api/survey/' + surveyId, questionsArray);
  }

  updateGdpr(surveyId: string, gdprValue: boolean) {
    return this.http.post('/api/gdpr/' + surveyId, { gdprValue });
  }

  getUserGdpr(surveyId: string) {
    return this.http.get('/api/gdpr/' + surveyId);
  }
}